/* Berater als Popup: Links auf die Berater-Seiten öffnen ein Fenster über der aktuellen Seite.
   Die Seite wird im Hintergrund geladen, nur der Berater-Teil wird ins Fenster gesetzt (Skripte werden dabei neu gestartet).
   Ergebnis-Links (Produkte) öffnen ganz normal im Hauptfenster. Ohne JavaScript bleibt der Link ein normaler Seitenlink. */
(function () {
  var RE = /^\/pages\/(maehroboter|saugroboter|fensterputzroboter)-berater\/?$/;
  var modal = null, body = null, opener = null, onKey = null, token = 0;

  function build() {
    modal = document.createElement('div');
    modal.className = 'rc-pop';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="rc-pop__scrim" data-rc-pop-close></div>' +
      '<div class="rc-pop__dialog" role="dialog" aria-modal="true" aria-label="Berater" tabindex="-1">' +
      '<button type="button" class="rc-pop__close" data-rc-pop-close aria-label="Berater schließen">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<div class="rc-pop__load" aria-hidden="true"><span></span></div>' +
      '<div class="rc-pop__body"></div></div>';
    document.body.appendChild(modal);
    body = modal.querySelector('.rc-pop__body');
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-rc-pop-close]')) close(); });
  }

  function activate(container) { // eingefügte Skripte ausführen
    Array.prototype.forEach.call(container.querySelectorAll('script'), function (old) {
      var type = old.getAttribute('type');
      if (type && type !== 'text/javascript' && type !== 'module') return; // z. B. JSON-Daten
      var s = document.createElement('script');
      Array.prototype.forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
      s.text = old.text;
      old.parentNode.replaceChild(s, old);
    });
  }

  function load(url, my) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (html) {
      if (my !== token) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var quiz = doc.querySelector('[data-rc-quiz]');
      if (!quiz) throw new Error('kein Berater');
      var wrap = quiz.closest('.shopify-section') || quiz.parentNode;
      // fehlende Stylesheets übernehmen
      var have = {};
      Array.prototype.forEach.call(document.querySelectorAll('link[rel=stylesheet]'), function (l) { have[l.getAttribute('href').split('?')[0]] = 1; });
      var waits = [];
      Array.prototype.forEach.call(doc.querySelectorAll('link[rel=stylesheet]'), function (l) {
        var h = l.getAttribute('href'); if (!h || have[h.split('?')[0]]) return;
        var n = document.createElement('link'); n.rel = 'stylesheet'; n.href = h;
        waits.push(new Promise(function (res) { n.onload = n.onerror = res; }));
        document.head.appendChild(n);
      });
      return Promise.all(waits).then(function () {
        if (my !== token) return;
        body.innerHTML = wrap.innerHTML;
        // Stylesheet-Links, die in der Section stehen, nicht doppelt laden
        Array.prototype.forEach.call(body.querySelectorAll('link[rel=stylesheet]'), function (l) { l.parentNode.removeChild(l); });
        activate(body);
        modal.classList.add('is-ready');
        body.scrollTop = 0;
      });
    });
  }

  function open(url, from) {
    if (!modal) build();
    opener = from || null;
    token++;
    modal.classList.remove('is-ready');
    body.innerHTML = '';
    modal.hidden = false;
    document.documentElement.classList.add('rc-pop-open');
    requestAnimationFrame(function () { modal.classList.add('is-open'); modal.querySelector('.rc-pop__dialog').focus(); });
    onKey = function (e) { if (e.key === 'Escape') close(); };
    document.addEventListener('keydown', onKey);
    load(url, token).catch(function () { close(); window.location.href = url; }); // Fallback: normale Seite
  }

  function close() {
    if (!modal || modal.hidden) return;
    token++;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('rc-pop-open');
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { if (!modal.classList.contains('is-open')) { modal.hidden = true; body.innerHTML = ''; } }, 220);
    if (opener && opener.focus) opener.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || (a.target && a.target !== '_self')) return;
    var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin || !RE.test(u.pathname)) return;
    if (RE.test(location.pathname)) return; // auf der Berater-Seite selbst normal weiter
    e.preventDefault();
    open(u.pathname, a);
  }, true);
})();
